import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const Wrapper = styled.div`
  margin-top: 24px;
`

const PlaneIcon = props => (
  <Wrapper>
    <svg width={props.width} height={props.height} viewBox="0 0 52 52">
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="step-3-v1---sem-senha"
          transform="translate(-614.000000, -234.000000)"
          stroke="#4A4A4A"
          strokeWidth="1.5"
        >
          <g id="icon-sent" transform="translate(615.000000, 235.000000)">
            <line x1="50" y1="0" x2="22.3404255" y2="27.6595745" id="Path" />
            <polygon id="Path" points="50 0 32.5 50 22.5 27.5 0 17.5" />
          </g>
        </g>
      </g>
    </svg>
  </Wrapper>
)

PlaneIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
}

PlaneIcon.defaultProps = {
  width: 52,
  height: 52,
}

export default PlaneIcon
